import { Card } from "@/components/ui/card";
import { AlertTriangle } from "lucide-react";

export default function MedicalDisclaimer() {
  return (
    <div className="min-h-screen pt-24 pb-12 px-6">
      <div className="max-w-3xl mx-auto">
        <Card className="p-8">
          <div className="flex items-center gap-3 mb-6">
            <AlertTriangle className="w-8 h-8 text-yellow-500" />
            <h1 className="text-3xl font-bold">Medical Disclaimer</h1>
          </div>
          
          <div className="space-y-6 text-muted-foreground">
            <div className="p-4 bg-yellow-500/10 border border-yellow-500/20 rounded-lg">
              <p className="text-yellow-400 font-medium">
                IMPORTANT: Please read this disclaimer carefully before using Bodyz Gym.
              </p>
            </div>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">Not Medical Advice</h2>
              <p>
                The information provided by Bodyz Gym, including AI-generated training plans, 
                exercise recommendations, and fitness guidance, is for informational and educational 
                purposes only. It is not intended to be a substitute for professional medical advice, 
                diagnosis, or treatment.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">Consult Your Physician</h2>
              <p>
                Always seek the advice of your physician or other qualified health provider with 
                any questions you may have regarding a medical condition or before beginning any 
                exercise program. Never disregard professional medical advice or delay in seeking it 
                because of something you have read on this application.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">Exercise Risks</h2>
              <p className="mb-2">
                Engaging in physical activity carries inherent risks, including but not limited to:
              </p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Muscle strains and sprains</li>
                <li>Joint injuries</li>
                <li>Cardiovascular stress</li>
                <li>Dehydration</li>
                <li>Exhaustion</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">When to Stop Exercising</h2>
              <p className="mb-2">Stop exercising immediately and seek medical attention if you experience:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Chest pain or pressure</li>
                <li>Severe shortness of breath</li>
                <li>Dizziness or lightheadedness</li>
                <li>Nausea</li>
                <li>Extreme fatigue</li>
                <li>Joint pain or swelling</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">Individual Results May Vary</h2>
              <p>
                The results achieved through using Bodyz Gym will vary from person to person. 
                Factors such as genetics, diet, sleep, stress levels, and consistency all play 
                a role in fitness outcomes. We do not guarantee any specific results.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">AI-Generated Content</h2>
              <p>
                Our training plans are generated using artificial intelligence (Google Gemini). 
                While we strive for accuracy, AI-generated content may not be appropriate for 
                everyone. Always use your judgment and consult with a fitness professional when 
                in doubt.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">Limitation of Liability</h2>
              <p>
                Jacaobtech Labs and Bodyz Gym are not responsible for any injuries, damages, or 
                health issues that may result from following the exercise programs or advice 
                provided through this application. You assume full responsibility for your use of 
                this service.
              </p>
            </section>

            <div className="p-4 bg-card border border-border rounded-lg mt-8">
              <p className="text-sm">
                By using Bodyz Gym, you acknowledge that you have read, understood, and agree 
                to this Medical Disclaimer. If you do not agree with any part of this disclaimer, 
                please do not use our services.
              </p>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}
